import { render, staticRenderFns } from "./DiProjectSelectorMultiple.vue?vue&type=template&id=376a7ce4&scoped=true&"
import script from "./DiProjectSelectorMultiple.vue?vue&type=script&lang=js&"
export * from "./DiProjectSelectorMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a7ce4",
  null
  
)

export default component.exports